import React, { useState } from 'react';
import { getImages } from '../Const';
import { SketchPicker } from 'react-color';
import { Formik, Form, Field } from 'formik';

const DefineStyle = ({ close, currentStyle, fieldName, setFieldValue }) => {
    const [showPicker, setShowPicker] = useState(false);
    const [color1, setColor1] = useState(currentStyle.color);
    const handleAddBtn = () => {
        close();
    }
    return (
        <>
            <div className='d-flex align-items-center justify-content-between ee-title-flex'>
                <div className='ee-title text-uppercase'>Define Style</div>
                <div>
                    <button type='button' className='ee-close' onClick={close}>
                        <img src={getImages('ee-close.svg')} alt="Close" />
                    </button>
                </div>
            </div>
            <div className='ee-body'>
                    <div className='form-group mb-3'>
                        <Field
                            type="text"
                            name={`${fieldName}.fontSize`}
                            className="form-control w-100 text-start"
                        />
                    </div>
                    <div className='form-group mb-3'>
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    backgroundColor: color1,
                                    border: '1px solid #ccc',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setShowPicker(!showPicker)}
                            />
                            <Field
                                type="text"
                                className="form-control ms-3"
                                name={`${fieldName}.color`}
                                value={color1 || currentStyle.color}
                                // readOnly
                            />
                        </div>
                        {showPicker && (
                            <div style={{ position: 'absolute', zIndex: 10 }}>
                                <SketchPicker
                                    color={color1}
                                    onChange={(selectedColor) => {
                                        setColor1(selectedColor.hex);
                                        setFieldValue(`${fieldName}.color`, selectedColor.hex);
                                    }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-secondary mt-2"
                                    onClick={() => setShowPicker(false)}
                                >
                                    Close
                                </button>
                            </div>
                        )}
                    </div>
                    <div className='text-end'>
                        <button type='button' onClick={handleAddBtn} className='blue-btn w-100'>Add</button>
                    </div>
            </div>
        </>
    );
};

export default DefineStyle;
